export const EnvironmentClientAttributeKeys = {
	clientId: 'Azure:ClientId',
	clientSecret: 'Azure:ClientSecret',
	clientSecretExpiresOn: 'Azure:ClientSecretExpiresOn',
	applicationId: 'Azure:ApplicationId',
	applicationObjectId: 'Azure:ApplicationObjectId',
	servicePrincipalId: 'Azure:ServicePrincipalId',
	tokenEndpoint: 'AuthenticationTokenEndpoint',
	openIdConfigurationEndpoint: 'Azure:OpenIdConfigurationEndpoint',
} as const;

export const environmentClientAttributeRows = [
	{ key: EnvironmentClientAttributeKeys.clientId, label: 'Client ID', secret: false },
	{ key: EnvironmentClientAttributeKeys.clientSecret, label: 'Client Secret', secret: true },
	{ key: EnvironmentClientAttributeKeys.clientSecretExpiresOn, label: 'Client Secret Expires On', secret: false },
	{ key: EnvironmentClientAttributeKeys.applicationId, label: 'App ID', secret: false },
	{ key: EnvironmentClientAttributeKeys.applicationObjectId, label: 'Object ID', secret: false },
	{ key: EnvironmentClientAttributeKeys.servicePrincipalId, label: 'Service Principal', secret: false },
	{ key: EnvironmentClientAttributeKeys.tokenEndpoint, label: 'Token Endpoint', secret: false },
	{ key: EnvironmentClientAttributeKeys.openIdConfigurationEndpoint, label: 'Metadata Endpoint', secret: false },
] as const;

export const knownEnvironmentClientAttributeKeys: ReadonlySet<string> = new Set(environmentClientAttributeRows.map((row) => row.key));
